module.exports = __webpack_public_path__ + "static/media/shirts2.e5f66a80.jpg";